(function () {
  var STYLE_ID = 'blog-product-embed-styles';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.product-block-embed{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:1.5rem;margin:2rem 0;}' +
      '.blog-product-card{position:relative;display:flex;flex-direction:column;height:100%;background-color:rgb(var(--background));border:1px solid rgba(var(--border-color),1);border-radius:var(--block-border-radius);overflow:hidden;}' +
      '.blog-product-card__image-wrapper{position:relative;display:block;padding-bottom:100%;background-color:rgb(var(--secondary-background));z-index:0;}' +
      '.blog-product-card__image{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;margin:0;}' +
      '.blog-product-card__info{position:relative;z-index:1;display:flex;flex-direction:column;gap:0.4em;padding:1.25em;}' +
      '.blog-product-card__title{position:static;display:block;margin:0;font-family:var(--heading-font-family);color:rgb(var(--heading-color));font-size:1.1em;line-height:1.3;text-decoration:none;}' +
      '.blog-product-card__title:hover{text-decoration:underline;}' +
      '.blog-product-card__price-list{display:flex;align-items:baseline;gap:0.5em;}' +
      '.blog-product-card__price{font-weight:600;color:rgb(var(--text-color));}' +
      '.blog-product-card__price--highlight{color:rgb(var(--product-on-sale-accent));}' +
      '.blog-product-card__price--compare{color:rgba(var(--text-color),0.55);text-decoration:line-through;}' +
      '.blog-product-card__cta{margin-top:0.5em;display:inline-flex;justify-content:center;padding:0.75em 1.25em;border-radius:var(--button-border-radius);background-color:rgb(var(--primary-button-background));color:rgb(var(--primary-button-text-color));font-family:var(--heading-font-family);font-size:0.9em;text-decoration:none;text-align:center;}' +
      '.blog-product-card__cta:hover{opacity:0.85;}';
    document.head.appendChild(style);
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return '$' + amount;
    }
  }

  function renderCard(product) {
    var imageUrl = product.featured_image || (product.images && product.images[0]) || '';
    var price = product.price;
    var compareAtPrice = product.compare_at_price;
    var onSale = compareAtPrice && compareAtPrice > price;
    var title = product.title || '';
    var safeTitle = title.replace(/"/g, '&quot;');

    var priceHtml = onSale
      ? '<span class="blog-product-card__price blog-product-card__price--highlight">' +
        formatMoney(price) +
        '</span><span class="blog-product-card__price blog-product-card__price--compare">' +
        formatMoney(compareAtPrice) +
        '</span>'
      : '<span class="blog-product-card__price">' + formatMoney(price) + '</span>';

    var card = document.createElement('div');
    card.className = 'blog-product-card blog-product-card--embed';
    card.innerHTML =
      '<a href="' + product.url + '" class="blog-product-card__image-wrapper">' +
      (imageUrl
        ? '<img class="blog-product-card__image" src="' + imageUrl + '" loading="lazy" alt="' + safeTitle + '">'
        : '') +
      '</a>' +
      '<div class="blog-product-card__info">' +
      '<a href="' + product.url + '" class="blog-product-card__title heading">' + title + '</a>' +
      '<div class="loox-rating" data-id="' + product.id + '" data-pattern="[count] reviews"></div>' +
      '<div class="blog-product-card__price-list">' + priceHtml + '</div>' +
      '<a href="' + product.url + '" class="blog-product-card__cta">Shop ' + title + '</a>' +
      '</div>';

    return card;
  }

  function hydrateEmbed(el) {
    var handles = (el.getAttribute('data-products') || '')
      .split(',')
      .map(function (h) {
        return h.trim();
      })
      .filter(Boolean);

    if (!handles.length) return;

    el.classList.add('product-block-embed');
    el.innerHTML = '';

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error('Product not found: ' + handle);
          return response.json();
        })
        .then(function (product) {
          el.appendChild(renderCard(product));
        })
        .catch(function (err) {
          console.warn('[blog-product-embed]', err.message);
        });
    });
  }

  function init() {
    var wrapper = document.querySelector('.article__content');
    if (!wrapper) return;

    var embeds = wrapper.querySelectorAll('.product-block-embed[data-products]');
    if (!embeds.length) return;

    injectStyles();
    embeds.forEach(hydrateEmbed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
